export default "__VITE_ASSET__050f6d61__"